import { render, staticRenderFns } from "./supportPages.vue?vue&type=template&id=0ce37236&lang=pug"
import script from "./supportPages.vue?vue&type=script&lang=js"
export * from "./supportPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports